export const uk = {
    add: 'Вибрати',
    cancel: 'Скасувати',
    title: 'Креатив «{creativeName}»'
};
